<template>
  <v-card>
    <v-card-title>
      <span class="title font-weight-light">สถานะ</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-container fluid grid-list-md>
        <v-layout row wrap>
          <v-flex xs12 md4>
            <v-subheader class="orange--text"><strong>สถานะการดำเนินการ</strong></v-subheader>
          </v-flex>
          <v-flex xs12 md8>
            <v-select
              :items="statusItems"
              v-model="form.status"
              label="สถานะ"
              item-text="text"
              item-value="value"
            ></v-select>
          </v-flex>
          <v-flex xs12 md12>
            <v-textarea
              outline
              v-model="form.remark"
              label="หมายเหตุ"
            ></v-textarea>
          </v-flex>
        </v-layout>
      </v-container> 
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <slot></slot>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: ['form'],
  data () {
    return {
      statusItems: [
        { text: 'คำขอใหม่', value: 'NEW' },
        { text: 'รอความเห็นจากประธานรายวิชา/อ.ประจำวิชา', value: 'PENDING_INSTRUCTOR' },
        { text: 'รอความเห็นจากหัวหน้าสำนักงาน', value: 'PENDING_OFFICER' },
        { text: 'รอความเห็นจากคณบดี', value: 'PENDING_DEAN' },
        { text: 'เสร็จสิ้น', value: 'COMPLETED' }
      ]
    }
  },
  computed: {

  },
  methods: {

  }
}
</script>


// WEBPACK FOOTER //
// src/components/management/student/formStatus.vue